import React, { PureComponent } from 'react'
import { number, arrayOf, shape, oneOf } from 'prop-types'
import { scaleLinear, select } from 'd3'
import { minBy, maxBy } from 'lodash'

export class SvgPoint extends PureComponent {
    static propTypes = {
        data: shape({
            x: number.isRequired,
            y: number.isRequired,
            r: number
        }).isRequired,
        inputRange: shape({
            x: arrayOf(number),
            y: arrayOf(number)
        }),
        outputViewBox: shape({
            x: number.isRequired,
            y: number.isRequired,
            width: number.isRequired,
            height: number.isRequired
        }).isRequired,
        animationDuration: number,
        startAnimation: oneOf(['none'/* , 'fadeIn' */]) // TODO: implement 'fadeIn'
    }

    static defaultProps = {
        inputRange: {},
        animationDuration: 1000,
        startAnimation: 'none'
    }

    componentWillMount() {
        const { startAnimation } = this.props
        this.point = null
        this.refreshScales(this.props)
        if (!startAnimation || startAnimation === 'none') {
            this.refreshPoint(this.props)
        }
    }
    componentDidMount() {
        const { startAnimation } = this.props
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.inputRange !== this.props.inputRange || nextProps.outputViewBox !== this.props.outputViewBox) {
            this.refreshScales(nextProps)
        }
        if (nextProps.data !== this.props.data) {
            this.refreshPoint(nextProps)
        }
    }

    setCircleRef = ref => {
        this.circleRef = ref
    }

    refreshScales = props => {
        const { data, inputRange, outputViewBox } = props
        let [xMin, xMax] = (inputRange || {}).x || [undefined, undefined]
        let [yMin, yMax] = (inputRange || {}).y || [undefined, undefined]
        if (typeof xMin !== 'number') xMin = minBy(data, d => d.x).x
        if (typeof xMax !== 'number') xMax = maxBy(data, d => d.x).x
        if (typeof yMin !== 'number') yMin = minBy(data, d => d.y).y
        if (typeof yMax !== 'number') yMax = maxBy(data, d => d.y).y
        this.xScale = scaleLinear().domain([xMin, xMax]).range([outputViewBox.x, outputViewBox.x + outputViewBox.width])
        this.yScale = scaleLinear().domain([yMin, yMax]).range([outputViewBox.y + outputViewBox.height, outputViewBox.y])
    }
    refreshPoint = props => {
        const { data, animationDuration } = props
        if (this.point) {
            const { x, y } = this.calculatePoint(data)
            select(this.circleRef).transition().duration(animationDuration).attr('cx', x).attr('cy', y)
        } else {
            this.point = this.calculatePoint(data)
        }
    }
    calculatePoint = data => {
        if (this.xScale && this.yScale) {
            return { x: this.xScale(data.x), y: this.yScale(data.y) }
        }
        return null
    }

    render() {
        const { data, inputRange, outputViewBox, animationDuration, startAnimation, className, ...otherProps } = this.props
        return this.point && (
            <circle ref={this.setCircleRef} className={['SvgPoint', className]} cx={this.point.x} cy={this.point.y} d={data.r} {...otherProps} />
        )
    }
}



// WEBPACK FOOTER //
// src/components/Svg/SvgPoint.js